export const siteInfo = {
  name: '91吃瓜网',
  slogan: '全网吃瓜 不打烊',
  description:
    '91吃瓜网为你追踪全网第一手明星翻车与国产91吃瓜大事件，实时更新91吃瓜不打烊。深度挖掘事件始末，让你走在吃瓜前线。',
  keywords:
    '91吃瓜,91吃瓜网,91吃瓜爆料,91在线吃瓜,91黑料吃瓜,91大瓜,吃瓜在线91,91吃瓜群众,91吃瓜网站,91吃瓜每日更新',
  url: 'http://epucz.cn/',
  logo: 'http://epucz.cn/logo.png',
  email: 'hello@epucz.cn',
  phone: '',
  founded: '2023',
  address: '',
  weibo: '',
  wechat: '91chigua_official',
  xiaohongshu: '',
  douyin: '',
};

export const categories = [
  {
    id: 'celebrity',
    slug: 'celebrity',
    name: '明星黑料',
    description: '追踪娱乐圈明星翻车、恋情曝光、合同纠纷等第一手爆料',
    color: 'bg-primary-500',
  },
  {
    id: 'influencer',
    slug: 'influencer',
    name: '网红翻车',
    description: '聚焦网红主播、带货达人翻车现场，揭露滤镜背后的真相',
    color: 'bg-accent-500',
  },
  {
    id: 'social',
    slug: 'social',
    name: '社会热点',
    description: '社会新闻、民生话题、奇闻异事，全网热搜一手掌握',
    color: 'bg-secondary-500',
  },
  {
    id: 'domestic',
    slug: 'domestic',
    name: '国产吃瓜',
    description: '国产剧、综艺、选秀内幕，深度挖掘娱乐圈未公开故事',
    color: 'bg-primary-600',
  },
];

export const articles = [
  {
    id: '1',
    slug: 'cai-xukun-new-route-controversy',
    title: '网红蔡徐刊新路线引发热议，网友直呼反差太大',
    summary:
      '知名网红蔡徐刊近日宣布转型新路线，从搞笑人设转向严肃知识博主，引发全网热议。粉丝数量三天内掉了15万，评论区沦陷。',
    content: `近日，拥有800万粉丝的知名网红蔡徐刊在直播中突然宣布，将全面转型为"严肃知识分享博主"，并下架了过往所有搞笑短视频。这一决定犹如一颗重磅炸弹，在吃瓜圈引发了巨大波澜。

据知情人透露，蔡徐刊此次转型背后另有隐情。其团队内部人士爆料称，此前蔡徐刊与某MCN机构因分成比例产生严重分歧，原机构持有其搞笑人设的IP版权，导致他不得不另辟蹊径。

转型后的第一条视频主题为《量子力学与人生哲学》，时长47分钟，全网播放量仅12万，与其以往动辄千万播放的数据形成鲜明对比。评论区前排热评写道："哥，求你回来搞笑吧，我真的看不懂。

更有细心的网友发现，蔡徐刊在视频中多次出现专业术语读错的情况，被相关领域博士博主逐帧拆解。截至目前，#蔡徐刊转型#话题阅读量已突破3.2亿，登上热搜榜第7位。我们将持续关注此事后续发展。`,
    category: '网红翻车',
    categorySlug: 'influencer',
    image:
      'https://readdy.ai/api/search-image?query=Controversial%20social%20media%20influencer%20press%20conference%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20photography%2C%20high%20contrast%2C%20editorial%20style&width=800&height=600&seq=article-01&orientation=landscape',
    author: '吃瓜一线',
    date: '2026-07-02',
    views: 2847362,
    tags: ['网红', '转型', '翻车', '蔡徐刊'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '2',
    slug: 'top-actor-tax-evasion-scandal',
    title: '顶流男星疑似偷税漏税，金额高达千万，工作室紧急回应',
    summary:
      '某顶流男星被曝通过阴阳合同、境外账户等方式偷逃税款，金额或超千万。税务局已介入调查，工作室发文否认但很快被删。',
    content: `据多家财经媒体联合调查，某L姓顶流男星（粉丝量超5000万）涉嫌通过签订阴阳合同、利用境外离岸公司转移收入等方式，在过去三年内偷逃税款金额累计超过1200万元。

消息人士称，该男星一部电视剧片酬报价8000万，但合同仅签署2000万，其余6000万通过其母亲名下的文化公司走账，并以"咨询服务费"名义开具发票避税。相关资金流已被税务部门锁定。

事件曝光后，该男星工作室于凌晨3点发布声明称"纯属谣言，将追究法律责任"，但蹊跷的是，该声明在发布2小时后即被删除。更有多家与其有代言合作的品牌方悄悄撤下相关物料，业内普遍认为这是在规避连带责任风险。

目前，国家税务总局已对此事作出回应，表示"正在核实相关情况，如确有违法将依法严肃处理"。91吃瓜网将持续追踪此事，敬请关注后续报道。`,
    category: '明星黑料',
    categorySlug: 'celebrity',
    image:
      'https://readdy.ai/api/search-image?query=Dark%20mysterious%20office%20with%20stacks%20of%20documents%20and%20financial%20papers%20scattered%2C%20dramatic%20spotlight%20lighting%2C%20red%20and%20black%20tones%2C%20cinematic%20film%20noir%20style%2C%20high%20detail&width=800&height=600&seq=article-02&orientation=landscape',
    author: '娱记小A',
    date: '2026-07-01',
    views: 5623411,
    tags: ['顶流', '偷税', '明星', '阴阳合同'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: '3',
    slug: 'livestream-queen-fake-sales-exposed',
    title: '带货女王直播间再曝假货丑闻，销售额破亿当晚翻车',
    summary:
      '坐拥2000万粉丝的带货女王在618大促当晚销售额破亿，却被消费者集体举报所售大牌包为高仿假货，品牌方已发律师函。',
    content: `618大促当晚，坐拥2000万粉丝的带货女王"XX姐"再创销售奇迹，单场直播带货金额突破1.2亿。然而狂欢过后，噩梦接踵而至。

6月20日起，多名消费者在社交平台晒出鉴定报告，称其直播间购买的某国际奢侈品牌手袋经专业机构鉴定为仿品。其中一位消费者表示："当时抢得很激动，说是品牌直供，假一赔十，结果拿去专柜保养被告知是假货。"

截至目前，已有超过300名消费者组建维权群，集体索赔金额预估超500万元。该奢侈品牌中国区公关部已确认从未授权其直播间销售，并表示"已委托律师发送律师函"。

值得注意的是，这并非该主播首次陷入假货争议。去年双11期间，其直播间售卖的某美妆品牌眼霜也曾被质疑为假货，但当时以"供应商问题"为由搪塞过去。此次事件能否不了了之，91吃瓜网将持续关注。`,
    category: '网红翻车',
    categorySlug: 'influencer',
    image:
      'https://readdy.ai/api/search-image?query=Chaotic%20livestream%20studio%20with%20broken%20products%20and%20scattered%20packaging%2C%20dramatic%20red%20warning%20lights%2C%20dark%20atmosphere%2C%20cinematic%20photography%2C%20high%20contrast%20editorial%20style&width=800&height=600&seq=article-03&orientation=landscape',
    author: '电商观察员',
    date: '2026-06-30',
    views: 4125893,
    tags: ['带货', '假货', '直播', '维权'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '4',
    slug: 'reality-show-vote-manipulation',
    title: '选秀节目投票数据遭黑客曝光，内定名单疑似流出',
    summary:
      '热门选秀综艺总决赛投票数据库被匿名黑客公开，显示多组选手票数存在人为修改痕迹，内定出道名单疑似提前确定。',
    content: `昨晚，某知名匿名黑客组织在暗网公布了某热门选秀综艺《星途闪耀》的原始投票数据库，文件大小达2.3GB，包含总决赛期间所有投票记录及系统操作日志。

数据分析人士指出，投票数据中存在大量"幽灵账号"，这些账号在决赛前三天集中注册，且投票IP高度集中于某几个城市机房。更关键的是，系统日志显示，在决赛结果公布前6小时，后台曾有管理员账号进行"票数校准"操作。

爆料文件中还包含一份标注为"最终出道方案"的PDF文档，创建时间为决赛前两周，其中7人出道名单与最终公布结果完全一致，甚至连名次排序都分毫不差。

节目制作方目前尚未对此作出正式回应，仅通过官方微博表示"网络信息真假难辨，请大家理性吃瓜"。但已有3位决赛选手的粉丝后援会宣布联合委托律师，要求彻查投票公正性。`,
    category: '国产吃瓜',
    categorySlug: 'domestic',
    image:
      'https://readdy.ai/api/search-image?query=Server%20room%20with%20glowing%20screens%20showing%20data%20and%20charts%2C%20dark%20cyberpunk%20atmosphere%2C%20red%20and%20blue%20accent%20lights%2C%20hacker%20aesthetic%2C%20cinematic%20photography&width=800&height=600&seq=article-04&orientation=landscape',
    author: '技术吃瓜',
    date: '2026-06-29',
    views: 3892105,
    tags: ['选秀', '黑幕', '投票', '黑客'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '5',
    slug: 'city-strange-traffic-jam-phenomenon',
    title: '某市高架桥连续7天莫名堵车，市民发现诡异规律',
    summary:
      '某二线城市高架桥每日早高峰准时出现3公里拥堵，但交警监控却查无事故。市民蹲守7天后发现惊人秘密。',
    content: `过去一周，某二线城市中环高架桥东向西方向每日早7:30准时出现长达3公里的拥堵，持续时间约40分钟。诡异的是，该路段并无交通事故、施工或信号灯，交警部门的智能监控系统也未能识别出异常成因。

市民王先生在连续蹲守7天后，用手机拍到了令人震惊的画面：每日7:28分左右，一辆黑色无牌豪车会从匝道汇入主线，并以不超过20km/h的龟速在最左侧车道行驶。紧随其后，3辆同款豪车依次以同样速度占据各车道，形成"移动路障"。待后方车辆排成长龙后，这些车辆会在下一个出口集体驶离。

视频曝光后，有网友爆料这些车辆属于当地某二手车商，"人为制造拥堵"是为了让其合作贴膜店在广播中插播广告——"前方拥堵，不如来XX贴膜"。当地交警已介入调查，该二手车商的抖音账号目前已被设为私密。`,
    category: '社会热点',
    categorySlug: 'social',
    image:
      'https://readdy.ai/api/search-image?query=Urban%20highway%20overpass%20at%20dawn%20with%20heavy%20traffic%20jam%2C%20orange%20street%20lights%2C%20moody%20atmosphere%2C%20cinematic%20photography%2C%20dark%20teal%20and%20warm%20orange%20contrast&width=800&height=600&seq=article-05&orientation=landscape',
    author: '社会观察',
    date: '2026-06-28',
    views: 5234789,
    tags: ['社会', '交通', '诡异', '营销'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: '6',
    slug: 'divorced-actress-secret-remarriage',
    title: '离婚女星被曝已秘密再婚，对象为某上市公司高管',
    summary:
      '去年刚官宣离婚的人气女星被拍到与神秘男子同进同出某高档小区，经查该男子为某A股上市公司副总，身家超10亿。',
    content: `去年9月刚官宣与圈内导演离婚的人气女星林某，近日被狗仔拍到与一名中年男子多次同进同出某均价18万/平的高档小区。

经多方查证，该男子为某A股上市科技公司的副总经理兼联合创始人，持股价值超10亿元。更巧的是，该公司正是林某前夫导演的某部电影的最大投资方。

网友扒出两人社交账号的蛛丝马迹：多次在同一时间发布定位相似的照片，男子书房中出现的艺术摆件与林某去年生日晒出的礼物高度一致。

林某工作室对此事的回应堪称经典——发布了一张林某独坐海边的背影照，配文"静享独处时光"，但照片角落的落地窗倒影中，清晰可见一个男人的轮廓。评论区瞬间沦陷，获赞最高评论为："姐，玻璃反光出卖了你。"

截至发稿，该上市公司股价今日上涨2.3%，被网友戏称"吃瓜概念股"。`,
    category: '明星黑料',
    categorySlug: 'celebrity',
    image:
      'https://readdy.ai/api/search-image?query=Luxury%20apartment%20entrance%20at%20night%20with%20two%20silhouetted%20figures%20walking%2C%20moody%20dramatic%20lighting%2C%20red%20and%20black%20color%20palette%2C%20cinematic%20paparazzi%20style%2C%20grainy%20high%20ISO&width=800&height=600&seq=article-06&orientation=landscape',
    author: '娱记小A',
    date: '2026-06-27',
    views: 6712458,
    tags: ['离婚', '再婚', '女星', '富豪'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '7',
    slug: 'college-entrance-exam-cheating-ring',
    title: '高考作弊产业链曝光：考场外雇人远程答题，明码标价',
    summary:
      '某地警方破获一起高科技高考作弊案，犯罪团伙在考场外架设信号设备，雇佣名校大学生远程答题，全套服务售价8万元。',
    content: `某地警方于高考期间破获一起组织考试作弊案，抓获犯罪嫌疑人12名，缴获微型耳机、信号接收器、加密对讲机等设备一批。

据调查，该犯罪团伙已运作3年，形成完整产业链：上游负责获取考试信号（利用改装过的智能手表接入考场WiFi漏洞），中游雇佣清华、北大等名校在读大学生实时答题，下游通过微型骨传导耳机将答案传递给考生。

全套服务明码标价：单科2万元，全科包过8万元，承诺"未达本科线全额退款"。警方在嫌疑人电脑中发现的客户名单涉及3个省份、共计47名考生。

令人唏嘘的是，负责答题的"枪手"中，有多名是依靠国家助学贷款完成学业的大学生。组织者正是利用其经济困难的处境，以"每科500元"的报酬诱使其参与犯罪。目前案件正在进一步侦办中。`,
    category: '社会热点',
    categorySlug: 'social',
    image:
      'https://readdy.ai/api/search-image?query=Examination%20classroom%20with%20hidden%20electronic%20devices%20and%20surveillance%20equipment%2C%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20cinematic%20photography%2C%20high%20contrast%20red%20accents&width=800&height=600&seq=article-07&orientation=landscape',
    author: '社会观察',
    date: '2026-06-26',
    views: 3456789,
    tags: ['高考', '作弊', '犯罪', '教育'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: '8',
    slug: 'variety-show-anchor-bullying-scandal',
    title: '综艺主持人 backstage 霸凌录音曝光，新人嘉宾当场落泪',
    summary:
      '某热播综艺主持人的 backstage 霸凌录音遭前工作人员泄露，内容涉及辱骂、威胁新人嘉宾，甚至要求对方下跪道歉。',
    content: `昨日，一位自称该综艺前编导的微博用户发布了一段长达23分钟的 backstage 录音，音频中某知名综艺主持人（主持某卫视黄金档综艺超10年）对一位新人嘉宾的恶劣态度令人咋舌。

录音中，该主持人因新人嘉宾在节目中"抢了自己的梗"而大发雷霆， backstage 关闭麦克风后对其吼道："你知道这个节目是谁撑着的吗？没有我你算个什么东西？"

更过分的是，该主持人要求新人嘉宾在全体工作人员面前下跪道歉，理由是"这是对前辈的基本尊重"。音频中可以清晰听到新人嘉宾抽泣的声音。

事件发酵后，该综艺的冠名商迅速撤换了官方微博中该主持人的宣传物料。但主持人至今未作任何回应，其粉丝后援会反而发布声明称"音频经过恶意剪辑，将追究造谣者责任"。然而，音频鉴定专家@声纹鉴证李博士 发文表示"经初步分析，该录音未经明显剪辑处理"。`,
    category: '国产吃瓜',
    categorySlug: 'domestic',
    image:
      'https://readdy.ai/api/search-image?query=Dark%20backstage%20corridor%20of%20TV%20studio%20with%20equipment%20and%20cables%2C%20single%20dramatic%20spotlight%2C%20moody%20atmosphere%2C%20red%20warning%20lights%2C%20cinematic%20documentary%20style&width=800&height=600&seq=article-08&orientation=landscape',
    author: '综艺扒皮',
    date: '2026-06-25',
    views: 4567234,
    tags: ['综艺', '霸凌', '主持人', '录音'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '9',
    slug: 'internet-celebrity-fake-degree-scandal',
    title: '知识型网红学历造假实锤，博士学位根本不存在',
    summary:
      '以"留美博士"人设走红、粉丝超300万的知识型网红被母校发声明否认，其博士学位在官方系统中查无此人。',
    content: `一直以"美国常青藤博士"身份活跃于各平台、粉丝超300万的知识博主"Dr.陈"，昨日被其自称的母校——某美国州立大学发布官方声明否认学籍。

该声明用中英双语发布，明确表示"本校从未授予名为陈某的博士学位，该人士并非我校注册学生"。更打脸的是，Dr.陈此前晒出的"毕业证书"上的校徽颜色与官方版本存在细微差异，被网友认定为PS痕迹。

深挖之下，有网友发现Dr.陈的真实学历仅为国内某三本院校本科毕业。其视频中所展示的专业知识，大多来自知网论文的"通俗化转述"，甚至有直接将某硕士论文摘要翻译成口语的案例。

事件曝光后，Dr.陈的账号已被平台标注"内容真实性存疑"，其知识付费课程"博士思维训练营"（售价999元/人，已售出1.2万份）的退款申请量激增。目前该博主已清空所有视频并关闭评论。`,
    category: '网红翻车',
    categorySlug: 'influencer',
    image:
      'https://readdy.ai/api/search-image?query=Forged%20diploma%20and%20academic%20documents%20on%20dark%20wooden%20desk%20with%20magnifying%20glass%20revealing%20flaws%2C%20dramatic%20lighting%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20photography&width=800&height=600&seq=article-09&orientation=landscape',
    author: '学历打假办',
    date: '2026-06-24',
    views: 2987456,
    tags: ['学历造假', '博士', '网红', '人设崩塌'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: '10',
    slug: 'film-awards-vote-buying-scandal',
    title: '电影节最佳影片投票疑云，评委收受千万红包被曝光',
    summary:
      '某A类电影节最佳影片评选被曝存在系统性投票舞弊，匿名评委向91吃瓜网提供转账记录，显示有片方发送六位数额红包。',
    content: `距离某A类国际电影节颁奖礼仅剩三天，91吃瓜网收到匿名举报材料，包含多张转账截图及聊天记录，直指最佳影片评选存在严重舞弊行为。

举报人自称是该电影节本届评委之一，因"良心不安"选择曝光。材料显示，某入围最佳影片的制片方通过中间人向5位评委发送了"评审费"，金额从88万到188万不等，均通过境外加密货币钱包转账。

更惊人的是聊天记录中的"投票指南"文档，详细标注了每位评委的投票偏好、私人关系及"攻克策略"，精确程度堪比商业情报。其中一位评委被标注为"喜欢文艺片但更爱钱，可收买"。

电影节组委会今日发布声明称"评选流程严格公正，不接受任何外部干涉"，但并未对具体举报内容作出回应。业内知情人士透露，组委会内部已成立"紧急应对小组"，原定出席颁奖礼的两位知名导演临时宣布"因身体原因缺席"。

这是国内电影节首次遭遇如此详细的舞弊证据曝光，事件最终走向备受关注。`,
    category: '国产吃瓜',
    categorySlug: 'domestic',
    image:
      'https://readdy.ai/api/search-image?query=Fancy%20film%20award%20statue%20on%20velvet%20pedestal%20with%20envelopes%20and%20cash%20surrounding%20it%2C%20dramatic%20spotlight%2C%20dark%20luxury%20atmosphere%2C%20gold%20and%20red%20accents%2C%20cinematic%20photography&width=800&height=600&seq=article-10&orientation=landscape',
    author: '娱记小A',
    date: '2026-06-23',
    views: 5342187,
    tags: ['电影节', '舞弊', '评委', '红包'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: '11',
    slug: 'celebrity-couple-fake-divorce-for-traffic',
    title: '明星夫妻被曝假离婚炒作，离婚声明日期早于登记日期',
    summary:
      '某明星夫妻的离婚声明被扒出发布日期竟早于民政局的离婚登记日期，网友质疑这是一场精心策划的流量收割。',
    content: `某明星夫妻上月高调官宣离婚，双方长文互撕引发全网围观，相关话题霸占热搜前三达5天之久。然而，细心的网友近日在民政局公开系统中发现惊人漏洞。

该夫妻的离婚登记日期为6月15日，但双方在社交媒体发布的离婚声明均显示为6月12日——也就是说，声明发出时两人法律上仍是夫妻关系。更离谱的是，声明中提到的"财产分割方案"与民政局备案的离婚协议内容存在多处不一致。

网友@福尔摩斯吃瓜 通过时间线梳理发现，离婚声明发布当天，女方刚好有新剧上线，男方则在3天后有综艺首播。而在离婚声明发布前一周，女方工作室已注册了"独立女性""离婚后重生"等多个商标。

业内人士透露，这种"预置离婚"是娱乐圈常见的营销手段：提前一个月办好手续但不公开，待有新作品上线时择机宣布，既收割流量又避免被指责"炒作"。但这对夫妻显然在日期把控上出了纰漏。

截至目前，双方均未回应日期争议，但已将各自社交账号设为"关注7天以上可评论"。`,
    category: '明星黑料',
    categorySlug: 'celebrity',
    image:
      'https://readdy.ai/api/search-image?query=Broken%20wedding%20rings%20on%20dark%20marble%20surface%20with%20scattered%20legal%20documents%20and%20stamped%20dates%2C%20dramatic%20side%20lighting%2C%20red%20and%20black%20color%20palette%2C%20cinematic%20photography&width=800&height=600&seq=article-11&orientation=landscape',
    author: '娱记小A',
    date: '2026-06-22',
    views: 7893456,
    tags: ['离婚', '炒作', '明星夫妻', '流量'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: '12',
    slug: 'mysterious-building-collapses-overnight',
    title: '某市烂尾楼深夜离奇倒塌，开发商早在一周前退保',
    summary:
      '某市中心烂尾三年的商业综合体在深夜突然倒塌，万幸无人员伤亡。更蹊跷的是，开发商在一周前悄悄退掉了所有工程保险。',
    content: `6月20日凌晨2时许，某市中心一座烂尾三年的大型商业综合体突然发生整体性倒塌。万幸的是，因项目已停工多年，现场无施工人员和住户，未造成人员伤亡。

然而，事件中的多个蹊跷之处引发舆论高度关注。首先，该建筑的设计使用年限为50年，结构检测报告（2024年12月出具）显示"主体结构基本完好"，为何会在无外力作用下倒塌？

其次，开发商在倒塌前一周（6月13日）悄悄退掉了工程一切险和第三者责任险，节省了约1200万元保费。若倒塌发生在投保期间，保险公司需赔付预估超3亿元的损失。

更巧合的是，该综合体所在地块已被纳入最新的城市更新规划，根据补偿方案，烂尾建筑的拆除成本由业主承担，但若建筑"自然倒塌"则可以获得更高的土地回收补偿。

目前，住建部门已介入调查，并委托第三方机构对倒塌原因进行鉴定。但截至发稿，开发商法人代表已处于"失联"状态，其最后一条朋友圈发布于倒塌当晚，配图是一杯红酒，配文"完美收工"。`,
    category: '社会热点',
    categorySlug: 'social',
    image:
      'https://readdy.ai/api/search-image?query=Collapsed%20building%20at%20night%20with%20emergency%20lights%20and%20dust%20cloud%2C%20dramatic%20red%20warning%20beacons%2C%20dark%20moody%20atmosphere%2C%20cinematic%20photography%2C%20high%20contrast%20editorial%20style&width=800&height=600&seq=article-12&orientation=landscape',
    author: '社会观察',
    date: '2026-06-21',
    views: 6234891,
    tags: ['烂尾楼', '倒塌', '开发商', '保险'],
    isHot: true,
    isExclusive: true,
  },
];

export const featuredArticles = articles.filter((a) => a.isHot).slice(0, 6);

export const exclusiveArticles = articles.filter((a) => a.isExclusive).slice(0, 4);

export const latestArticles = [...articles].sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
);

export const hotTags = [
  { name: '偷税漏税', count: 3829 },
  { name: '人设崩塌', count: 2956 },
  { name: '直播间翻车', count: 2643 },
  { name: '离婚大战', count: 2412 },
  { name: '学历造假', count: 1987 },
  { name: '黑幕曝光', count: 1756 },
  { name: '吃瓜群众', count: 1543 },
  { name: '爆料有奖', count: 1321 },
];

export const comments = [
  {
    id: '1',
    user: '吃瓜不吐籽',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20person%20portrait%20with%20neutral%20expression%2C%20soft%20natural%20lighting%2C%20clean%20background%2C%20square%20format%20avatar%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    level: '资深瓜农',
    content:
      '这个瓜我从头跟到尾，只能说现在的明星真是把网友当傻子。离婚声明比离婚登记还早，编剧都不敢这么写。',
    articleTitle: '明星夫妻被曝假离婚炒作',
  },
  {
    id: '2',
    user: '前线侦察兵',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20with%20slight%20smile%2C%20soft%20studio%20lighting%2C%20neutral%20background%2C%20square%20format%20avatar%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    level: '金牌线人',
    content:
      '作为某娱乐公司的前员工，我可以证实类似操作在圈内非常普遍。很多"官宣"的时间都是精心计算过的，根本不是什么"缘分到了"。',
    articleTitle: '选秀节目投票数据遭黑客曝光',
  },
  {
    id: '3',
    user: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20asian%20man%20portrait%20with%20glasses%2C%20thoughtful%20expression%2C%20soft%20lighting%2C%20clean%20background%2C%20square%20format%20avatar%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    level: '初级瓜农',
    content:
      '那个高架桥堵车的新闻真的太离谱了，为了卖个广告居然去制造交通堵塞，这已经不是营销的问题，是危害公共安全了吧？',
    articleTitle: '某市高架桥连续7天莫名堵车',
  },
  {
    id: '4',
    user: '娱乐圈纪检委',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20with%20confident%20expression%2C%20professional%20headshot%20style%2C%20soft%20lighting%2C%20square%20format%20avatar&width=100&height=100&seq=avatar-04&orientation=squarish',
    level: '顶级瓜王',
    content:
      '电影节那个料，我在圈内早有耳闻。其实很多奖项的评选早就不是看作品质量了，而是看谁的"公关费"给得足。这次被实锤了也是活该。',
    articleTitle: '电影节最佳影片投票疑云',
  },
  {
    id: '5',
    user: '早九晚五吃瓜',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20man%20portrait%20with%20casual%20smile%2C%20natural%20lighting%2C%20outdoor%20background%2C%20square%20format%20avatar%20style&width=100&height=100&seq=avatar-05&orientation=squarish',
    level: '资深瓜农',
    content:
      '蔡徐刊那个转型的瓜吃得好心酸。从搞笑博主转型知识博主，结果是团队内斗的牺牲品。人设这个东西，说崩就崩啊。',
    articleTitle: '网红蔡徐刊新路线引发热议',
  },
];

export const aboutFaq = [
  {
    question: '91吃瓜网是什么？',
    answer:
      '91吃瓜网是一个专注于追踪全网娱乐八卦、明星翻车、网红迷路事件与社会热点的中文爆料资讯平台。我们致力于第一时间挖掘事件始末，还原真相，让每一位吃瓜群众都能走在吃瓜前线。',
  },
  {
    question: '91吃瓜网的内容来源可靠吗？',
    answer:
      '91吃瓜网的所有内容均来自公开渠道的信息整合与深度调查，包括官方公告、法院文书、企业工商信息、当事人社交账号等可溯源资料。我们严格区分"已证实信息"与"网传爆料"，并在文中明确标注信息来源与可信度。',
  },
  {
    question: '如何向91吃瓜网投稿爆料？',
    answer:
      '如果您掌握有价值的爆料线索，可以通过网站右上角的"投稿入口"提交。我们接受文字、图片、音频、视频等多种形式的爆料材料。对于经核实后发布的独家爆料，我们将根据内容价值给予最高5000元的奖励。所有爆料者身份严格保密。',
  },
  {
    question: '91吃瓜网会保护爆料者隐私吗？',
    answer:
      ' absolutely。保护爆料者隐私是91吃瓜网的首要原则。我们采用端到端加密技术传输爆料材料，内部实行严格的"最小知情原则"——只有直接负责核实的编辑可以接触爆料者原始信息。历史上从未发生过爆料者身份泄露事件。',
  },
  {
    question: '如何联系91吃瓜网？',
    answer:
      '您可以通过以下方式联系我们：商务合作邮箱 hello@epucz.cn；爆料投稿邮箱 hello@epucz.cn；客服咨询邮箱 hello@epucz.cn。工作日12小时内回复，紧急事项请加急标注。',
  },
  {
    question: '91吃瓜网的内容更新频率如何？',
    answer:
      '91吃瓜网实行7×24小时不间断更新机制。重大突发爆料将在发生后30分钟内发布快讯，深度调查报道通常在48小时内完成撰写与审核。关注我们的微信公众号与微博，可第一时间接收推送提醒。',
  },
];

export const siteStats = [
  { label: '日更黑料', value: '100+', description: '每日更新爆料数量' },
  { label: '全网覆盖', value: '50+', description: '覆盖平台与渠道' },
  { label: '忠实瓜农', value: '200万+', description: '日均活跃用户数' },
];
